import React, { FC } from 'react';
import { CircularLoading, Size } from '@src/components/CircularLoading';
import { useQueryParams } from '@src/customHooks/useQueryParams';
import { QueryParams } from '../interfaces/queryParams.interface';
import { InboxCandidateProfile } from './InboxCandidateProfile';
import { Chat } from './Chat';
import { ConversationProps } from './props';
import './styles.scss';

export const Conversation: FC<ConversationProps> = ({
  isThreadLoading,
  messageThread,
  doesUserVerificationProfileExist,
  onAccept,
  onClose,
  onDecline,
  onInputChange,
  onReopen,
  sendMessage,
  markUnread,
  chatInputMessage,
  onChatArchive,
  openActionsModal,
}) => {
  const { queryParams } = useQueryParams<QueryParams>();

  return (
    <div className="inbox-conversation">
      {isThreadLoading && (
        <div className="inbox-conversation__loading-placeholder">
          <CircularLoading size={Size.SMALL} />

          <div className="inbox-conversation__loading-placeholder-text">Loading...</div>
        </div>
      )}

      {!isThreadLoading && !queryParams.threadId && (
        <div className="inbox-conversation__unselected-placeholder">Select an applicant from the list.</div>
      )}

      {!isThreadLoading && !!messageThread && messageThread.id === queryParams?.threadId && (
        <>
          <Chat
            doesUserVerificationProfileExist={doesUserVerificationProfileExist}
            messageThread={messageThread}
            onAccept={onAccept}
            onClose={onClose}
            onDecline={onDecline}
            onInputChange={onInputChange}
            onReopen={onReopen}
            sendMessage={sendMessage}
            typedMessage={chatInputMessage}
          />

          <div className="inbox-conversation__candidate-information">
            <InboxCandidateProfile
              markUnread={markUnread}
              messageThread={messageThread}
              onChatArchive={onChatArchive}
              onChatClose={() => openActionsModal()}
            />
          </div>
        </>
      )}
    </div>
  );
};
